import Vue from 'vue'
import Vuex from 'vuex'
import modules from '../store/modules'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules
})
export default store

const initialStateCopy = JSON.parse(JSON.stringify(store.state))

export const resetVuexState = () => {
  store.replaceState(JSON.parse(JSON.stringify(initialStateCopy)))
}
